import { LinkContentScheme } from "@ecp-boxes/settingsPatterns/contentPatterns.scheme";
import {
  SelectedCategoryOption,
  SelectedGoToOption,
} from "@ecp-boxes/settingsPatterns/contentPatterns.types";
import {
  AlignmentScheme,
  Border_v3Scheme,
  ColorReadoutValueScheme,
  LinkReadoutValueScheme,
  RadiusScheme,
  TypoReadoutValueScheme,
} from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import {
  AlignmentHorizontalOption,
  OutlineOptions,
  AlignmentVerticalOption,
  VerticalPosition,
} from "@ecp-redux/dto/themeSettings/themeSettings.types";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { z } from "zod";

export const IBoxCategoriesSettingsScheme = z.object({
  one_product_page_url: themeScheme.UrlScheme.default("").catch(""),
  two_products_page_url: themeScheme.UrlScheme.default("").catch(""),
  four_products_page_url: themeScheme.UrlScheme.default("").catch(""),
});

export const BoxCategoriesContentScheme = z
  .object({
    header: z.string().default("Tiles title"),
    tiles: z
      .array(
        z.object({
          id: z.string().default("tile1"),
          image: z
            .object({
              iconDefault: z.string().default(""),
              iconUnmarked: z.string().default(""),
              iconHover: z.string().default(""),
              iconActive: z.string().default(""),
            })
            .default({
              iconDefault: "",
              iconUnmarked: "",
              iconHover: "",
              iconActive: "",
            }),
          linkStyle: LinkReadoutValueScheme,
          title: z.string().default("Tile2222222"),
          slideUrl: LinkContentScheme.default({
            showLinkOptions: true,
            selectedGoToOption: SelectedGoToOption.GO_TO_PAGE,
            goToRowSetting: undefined,
            goToPageSetting: { link: "", openInNewTab: false },
            forceOrderInsideStack: undefined,
            openPopupSetting: undefined,
            closePopupSetting: undefined,
          }),
          seoDescription: z.string().default(""),
        })
      )
      .default([]),
  })
  .default({});

export const BoxCategoriesContentSettingsScheme = z
  .object({
    headerTextStyle: TypoReadoutValueScheme,
    headerTextColor: ColorReadoutValueScheme,
    headerAlignment: z
      .nativeEnum(AlignmentHorizontalOption)
      .default(AlignmentHorizontalOption.LEFT),
    spaceBetweenTitleAndTiles: z.number().default(10),
    tileHeight: z.number().default(600),
    numberOfTilesPerSlide: z.number().default(4),
    spaceBetweenTiles: z.number().default(5),
    tileBorder: Border_v3Scheme.default({
      width: { top: 0, right: 0, bottom: 0, left: 0 },
      color: { id: "color$$1", custom: "#FFFFFF" },
      style: OutlineOptions.NONE,
      radius: { top: 0, right: 0, bottom: 0, left: 0 },
    }),
    tileHoverBorder: Border_v3Scheme.default({
      width: { top: 0, right: 0, bottom: 0, left: 0 },
      color: { id: "color$$1", custom: "#FFFFFF" },
      style: OutlineOptions.NONE,
      radius: RadiusScheme.default({
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0,
      }),
    }),
    tilesBackground: ColorReadoutValueScheme,
    tilesBackgroundHover: ColorReadoutValueScheme,
    tileSettings: z
      .array(
        z.object({
          id: z.string().default("tile1"),
          fill: z.boolean().default(true),
          image: z
            .object({
              opacity: z.number().default(100),
              alignment: AlignmentScheme.default({
                horizontal: AlignmentHorizontalOption.CENTER,
                vertical: AlignmentVerticalOption.CENTER,
              }),
              imageSize: z
                .object({
                  auto: z.boolean().default(true).catch(true),
                  height: z.number().nullable().default(null).catch(null),
                })
                .default({ auto: true, height: null })
                .catch({ auto: true, height: null }),
            })
            .default({
              opacity: 100,
              alignment: {
                horizontal: AlignmentHorizontalOption.CENTER,
                vertical: AlignmentVerticalOption.CENTER,
              },
              imageSize: { auto: true, height: null },
            }),
          titleStyle: TypoReadoutValueScheme,
          titleColor: ColorReadoutValueScheme,
          titleAlignment: z
            .nativeEnum(AlignmentHorizontalOption)
            .default(AlignmentHorizontalOption.CENTER),
          titlePlacement: z
            .nativeEnum(VerticalPosition)
            .default(VerticalPosition.TOP),
          spaceBetweenTitleAndImage: z.number().default(5),
          adOrProduct: z
            .object({
              selectedCategoryOption: z
                .nativeEnum(SelectedCategoryOption)
                .default(SelectedCategoryOption.AD),
              adUrl: themeScheme.UrlScheme.default("").catch(""),
              firstProductSku: z.string().default("").catch(""),
              secondProductSku: z.string().default("").catch(""),
              thirdProductSku: z.string().default("").catch(""),
              fourthProductSku: z.string().default("").catch(""),
            })
            .default({
              selectedCategoryOption: SelectedCategoryOption.AD,
              adUrl: "",
              firstProductSku: "",
              secondProductSku: "",
              thirdProductSku: "",
              fourthProductSku: "",
            })
            .default({}),
          show: z
            .object({
              image: z.boolean().default(true),
              title: z.boolean().default(true),
              link: z.boolean().default(true),
              productAd: z.boolean().default(true),
            })
            .default({ image: true, title: true, link: true, productAd: true }),
        })
      )
      .default([]),
  })
  .default({
    headerTextStyle: { id: "typo$$1", custom: {} },
    headerTextColor: { id: "color$$1", custom: "#FFFFFF" },
    headerAlignment: AlignmentHorizontalOption.LEFT,
    spaceBetweenTitleAndTiles: 10,
    tileHeight: 600,
    numberOfTilesPerSlide: 4,
    spaceBetweenTiles: 5,
    tileBorder: {
      width: { top: 0, right: 0, bottom: 0, left: 0 },
      color: { id: "color$$1", custom: "#FFFFFF" },
      style: OutlineOptions.NONE,
      radius: { top: 0, right: 0, bottom: 0, left: 0 },
    },
    tileHoverBorder: {
      width: { top: 0, right: 0, bottom: 0, left: 0 },
      color: { id: "color$$1", custom: "#FFFFFF" },
      style: OutlineOptions.NONE,
      radius: { top: 0, right: 0, bottom: 0, left: 0 },
    },
    tilesBackground: { id: "color$$1", custom: "#FFFFFF" },
    tilesBackgroundHover: { id: "color$$1", custom: "#FFFFFF" },
    tileSettings: [],
  });
